'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  color: #007bff;\n  text-decoration: none;\n  background-color: transparent;\n  &:hover {\n    color: #0056b3;\n    text-decoration: underline;\n  };\n'], ['\n  color: #007bff;\n  text-decoration: none;\n  background-color: transparent;\n  &:hover {\n    color: #0056b3;\n    text-decoration: underline;\n  };\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var A = exports.A = _styledComponents2.default.a(_templateObject);